export default "__VITE_ASSET__BFgHcfym__"